export const DEFAULT_PROVIDER_SUBSCRIPTION_ID = 'ProductSubscription:88f8b0e6-af76-424a-9e91-89b2290c5cf0';
